import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'balance-entries', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'balance-entries',
    loadComponent: () =>
      import('./wrapper/wrapper.component').then((m) => m.WrapperComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/balance-entries/balance-entries.component').then(
            (m) => m.BalanceEntriesComponent
          ),
      },
    ],
  },
  {
    path: 'field-logs',
    loadComponent: () =>
      import('./wrapper/wrapper.component').then((m) => m.WrapperComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/field-logs/field-logs.component').then(
            (m) => m.FieldLogsComponent
          ),
      },
    ],
  },
  {
    path: 'machines',
    loadComponent: () =>
      import('./wrapper/wrapper.component').then((m) => m.WrapperComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/machines/machines.component').then(
            (m) => m.MachinesComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'balance-entries' },
];
